var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headline-container',{attrs:{"headline":"Marketing Sites","breadcrumbs":_vm.breadcrumbs}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('list-panel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }